import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, EmptyState } from "@/components/Bits";

export default function ParentNotices() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/notifications").then(r => setItems(r.data)); }, []);
  return (
    <div>
      <PageHeader eyebrow="Notices" title="Centre notices & alerts" subtitle="Everything your centre wants you to know." />
      {items.length === 0 ? <EmptyState title="You're all caught up" /> : (
        <div className="space-y-3 max-w-3xl">
          {items.map(n => (
            <div key={n.notification_id} className="bg-white rounded-3xl border border-border p-5">
              <div className="font-heading font-bold">{n.title}</div>
              <div className="text-sm text-ink-soft mt-1">{n.body}</div>
              <div className="text-xs text-ink-soft mt-3">{new Date(n.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
